import React from 'react'
import IconWrapper, { IconProps } from './IconWrapper'

export const WikipediaIcon = (props: IconProps) => (
    <IconWrapper {...props}>
        <svg
            version="1.1"
            x="0px"
            y="0px"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            enableBackground="new 0 0 24 24"
            xmlSpace="preserve"
            aria-hidden="true"
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M23.254 5.572c-.445.027-.87.197-1.211.484-.43.457-.76.997-.972 1.587l-5.104 11.744q-.053.163-.282.163a.31.31 0 0 1-.282-.163l-2.862-6.12-3.294 6.116a.31.31 0 0 1-.281.163.28.28 0 0 1-.29-.163L3.663 7.636a4.1 4.1 0 0 0-.988-1.513 2.68 2.68 0 0 0-1.453-.535.2.2 0 0 1-.15-.088A.3.3 0 0 1 1 5.302q0-.286.159-.286.67 0 1.4.06.732.06 1.283.06.61 0 1.44-.06t1.54-.06q.16 0 .16.286 0 .285-.1.286a1.95 1.95 0 0 0-1.056.349.93.93 0 0 0-.397.794c.012.213.066.422.159.615l4.163 9.525 2.354-4.54L9.91 7.636a6.1 6.1 0 0 0-.972-1.62 1.92 1.92 0 0 0-1.151-.444.18.18 0 0 1-.135-.088.33.33 0 0 1-.064-.198q0-.286.14-.286.615-.003 1.23.06.574.062 1.15.06.6 0 1.27-.06Q12.05 5 12.74 5q.159 0 .159.286 0 .285-.1.286-1.341.09-1.341.793c.04.334.147.657.313.949l1.453 3.008 1.44-2.75c.175-.3.279-.635.303-.98q0-.94-1.342-1.004-.12 0-.12-.286.002-.106.06-.195.06-.09.12-.09.48 0 1.19.059.71.06 1.1.06.31 0 .908-.052.763-.072 1.27-.072.12 0 .12.246 0 .326-.219.326a2.5 2.5 0 0 0-1.254.44 5.6 5.6 0 0 0-1.19 1.627l-1.925 3.632 2.603 5.421 3.842-9.128a2.5 2.5 0 0 0 .198-.92q0-1.005-1.341-1.064-.12 0-.12-.286t.18-.286q.492 0 1.162.06.672.06 1.04.06.512-.004 1.02-.06.544-.068 1.092-.08.138 0 .139.246a.37.37 0 0 1-.076.226.21.21 0 0 1-.17.1"
                clipRule="evenodd"
            ></path>
        </svg>
    </IconWrapper>
)
